import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { a as isErrorCodeResult, b as isValidationErrorResult, c as isNotNullOrEmptyString, i as isCanceledError, d as isAxiosResponse, e as isAxiosErrorResponse } from './baseAccount-863ddd48.js';
import { ai as notistack, aj as locale, ak as dateFns } from './AccountTreeList-e643cfcf.js';
import { useRef, useCallback, useState, useEffect, useMemo } from 'react';
import { isEmpty, reduce, isNil } from 'lodash';
import { useSelector } from 'react-redux';
import './index-d8f55c20.js';
import { useLocation } from 'react-router-dom';
import { _ as __assign, b as __spreadArray } from './_tslib-ff3a08af.js';
import { a as Prompt } from './Prompt-bf2f8ed4.js';
import { f as selectUserLanguage } from './userProfileSelectors-33b20ef0.js';
import { useJsApiLoader, GoogleMap } from '@react-google-maps/api';
import { renderToString } from 'react-dom/server';
import './globalButtonStyles-41c8af84.js';
import '@material-ui/core';
import 'typescript-cookie';
import '@material-ui/lab/Autocomplete';
import './SearchInput-9fbcf52e.js';
import 'react-select/async';
import '@material-ui/core/SvgIcon';
import './ClearIndicator-e1d121b8.js';
import 'react-select/async-creatable';
import 'react-select';
import './CustomSelect-aeddb5fe.js';
import '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/ChevronRight';
import '@material-ui/icons';
import { L as LoadingData } from './LoadingData-d24d8384.js';
import './Button-3cc41ab2.js';
import './CustomInput-7f72fe33.js';
import './Gallery-4ad7f646.js';
import './InformationTooltip-7059c75f.js';
import '@material-ui/icons/MenuRounded';
import './NotFound.styles-db4376d0.js';
import './LabeledValue-35614cb5.js';
import '@material-ui/icons/Star';
import './SelectableStar.styles-90bbef1f.js';
import '@reduxjs/toolkit';
import { G as GoogleMarkerOrder } from './googleMap-97aeb4f7.js';

var translateAndParseErrorCode = function (error, errorCodesDictionary) {
    var _a, _b;
    var messages = [];
    if (isErrorCodeResult(error)) {
        var mappedCode = (_a = errorCodesDictionary === null || errorCodesDictionary === void 0 ? void 0 : errorCodesDictionary[error === null || error === void 0 ? void 0 : error.errorCode]) !== null && _a !== void 0 ? _a : error === null || error === void 0 ? void 0 : error.errorCode;
        messages.push(mappedCode);
    } else if (isValidationErrorResult(error)) {
        error.data.forEach(function (err) {
            var _a;
            (_a = err === null || err === void 0 ? void 0 : err.errors) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
                var _b, _c;
                var code = _a.code,
                    message = _a.message;
                var mappedCode = (_c = (_b = errorCodesDictionary === null || errorCodesDictionary === void 0 ? void 0 : errorCodesDictionary[code]) !== null && _b !== void 0 ? _b : message) !== null && _c !== void 0 ? _c : code;
                messages.push(mappedCode);
            });
        });
    } else if (isNotNullOrEmptyString(error)) {
        var mappedCode = (_b = errorCodesDictionary === null || errorCodesDictionary === void 0 ? void 0 : errorCodesDictionary[error]) !== null && _b !== void 0 ? _b : error;
        messages.push(mappedCode);
    }
    return isEmpty(messages) ? null : messages.length === 1 ? messages[0] : messages === null || messages === void 0 ? void 0 : messages.join(', ');
};

var useNotifications = function (errorCodesDictionary) {
    var notifications = useRef({
        handleSuccess: useHandleSuccess(),
        handleError: useHandleError(errorCodesDictionary),
        handleWarning: useHandleWarning()
    });
    return notifications.current;
};
var useHandleError = function (errorCodesDictionary) {
    var globalHandledErrorCodes = [403, 500];
    var enqueueSnackbar = notistack.useSnackbar().enqueueSnackbar;
    var handleError = useCallback(function (error, context, customMessage) {
        var _a, _b;
        var isCanceledErr = isCanceledError(error);
        var isGlobalErr = isAxiosResponse(error) && globalHandledErrorCodes.some(function (x) {
            return x === error.status;
        });
        if (isCanceledErr || isGlobalErr) {
            return;
        }
        if (customMessage) {
            enqueueSnackbar(createMessage(customMessage, context), { variant: 'error' });
            return;
        }
        if (!error) {
            enqueueSnackbar(createMessage('An error has occurred', context), { variant: 'error' });
            return;
        }
        var parsedError = isAxiosErrorResponse(error) ? (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data : error;
        var errToDisplay = (_b = translateAndParseErrorCode(parsedError, errorCodesDictionary)) !== null && _b !== void 0 ? _b : 'An error has occurred';
        enqueueSnackbar(createMessage(errToDisplay, context), { variant: 'error' });
    }, [enqueueSnackbar]);
    return handleError;
};
var useHandleSuccess = function () {
    var enqueueSnackbar = notistack.useSnackbar().enqueueSnackbar;
    var handleSuccess = useCallback(function (message, header) {
        enqueueSnackbar(createMessage(message, header), { variant: 'success' });
    }, [enqueueSnackbar, createMessage]);
    return handleSuccess;
};
var useHandleWarning = function () {
    var enqueueSnackbar = notistack.useSnackbar().enqueueSnackbar;
    var handleWarning = function (message, header) {
        enqueueSnackbar(createMessage(message, header), { variant: 'warning' });
    };
    return handleWarning;
};
var createMessage = function (message, context) {
    var header = context ? context + ': ' : '';
    return jsxs("div", { style: { margin: 0, padding: 0 }, children: [jsx("span", { style: { fontWeight: 700 }, children: header }), message] });
};

var CountriesLocale = {
    'en-GB': locale.enGB,
    'en-US': locale.enUS,
    'en-MY': locale.enGB,
    'de-DE': locale.de,
    'es-ES': locale.es,
    'fr-FR': locale.fr,
    'hr-HR': locale.hr,
    'fa-IR': locale.faIR,
    'ko-KR': locale.ko,
    'tr-TR': locale.tr,
    'vi-VN': locale.vi,
    'zh-SG': locale.zhCN,
    'zh-TW': locale.zhTW,
    'el-GR': locale.el,
    'ro-RO': locale.ro,
    'it-IT': locale.it,
    'sv-SE': locale.sv,
    'fi-FI': locale.fi,
    'nb-NO': locale.nb,
    'da-DK': locale.da,
    'pl-PL': locale.pl,
    'lt-LT': locale.lt
};
var CountriesDateFormats = {
    'en-GB': 'dd/MM/yyyy HH:mm',
    'en-MY': 'dd/MM/yyyy HH:mm',
    'es-ES': 'dd/MM/yyyy HH:mm',
    'fr-FR': 'dd/MM/yyyy HH:mm',
    'vi-VN': 'dd/MM/yyyy HH:mm',
    'ro-RO': 'dd/MM/yyyy HH:mm',
    'it-IT': 'dd/MM/yyyy HH:mm',
    'da-DK': 'dd/MM/yyyy HH:mm',
    'en-US': 'MM/dd/yyyy h:mm a', // AM / PM
    'de-DE': 'dd.MM.yyyy HH:mm',
    'tr-TR': 'dd.MM.yyyy HH:mm',
    'nb-NO': 'dd.MM.yyyy HH:mm',
    'pl-PL': 'dd.MM.yyyy HH:mm',
    'hr-HR': 'dd. MM. yyyy. HH:mm',
    'fa-IR': 'yyyy/MM/dd h:mm a', //  AM - ق.ظ. / PM - ب.ظ.
    'ko-KR': 'yyyy.MM.dd HH:mm',
    'zh-SG': 'yy-MM-dd a h:mm', // AM - 上午 / PM - 下午
    'zh-TW': 'yy-MM-dd a h:mm', // AM - 上午 / PM - 下午
    'el-GR': 'dd/M/yy h:mm a', // AM - π.μ. / PM - μ.μ.
    'sv-SE': 'yyyy-MM-dd HH:mm',
    'lt-LT': 'yyyy-MM-dd HH:mm',
    'fi-FI': 'dd.M.yyyy HH.mm'
};
//
var isDateAsString = function (val) {
    return (val === null || val === void 0 ? void 0 : val.split) !== undefined;
};
var parseStringToDate = function (date) {
    if (!date) return null;
    var splittedDateString = date.split('+')[0].split('Z')[0];
    var indexOfT = splittedDateString.indexOf('T');
    // negative offset
    if (indexOfT !== -1 && indexOfT < (splittedDateString === null || splittedDateString === void 0 ? void 0 : splittedDateString.lastIndexOf('-'))) {
        var dateString = splittedDateString === null || splittedDateString === void 0 ? void 0 : splittedDateString.slice(0, splittedDateString === null || splittedDateString === void 0 ? void 0 : splittedDateString.lastIndexOf('-'));
        return dateFns.parseISO(dateString);
    }
    return dateFns.parseISO(splittedDateString);
};
var formatDateWithCustomCountry = function (date, country) {
    var _a;
    if (!date) return null;
    var locale$1 = (_a = CountriesLocale[country]) !== null && _a !== void 0 ? _a : locale.enGB;
    var dateFormat = CountriesDateFormats[country];
    var parsedDate = isDateAsString(date) ? parseStringToDate(date) : date;
    if (!parsedDate) return null;
    return dateFns.format(parsedDate, dateFormat, {
        locale: locale$1
    });
};
var formatDateForApi = function (date, dateWithoutTime) {
    if (!date) return null;
    var parsedDate = isDateAsString(date) ? parseStringToDate(date) : date;
    if (!parsedDate) return null;
    return dateFns.format(parsedDate, "yyyy-MM-dd".concat(dateWithoutTime ? '' : "'T'HH:mm:ss"));
};
var useFormatDate = function () {
    var _a;
    var language = useSelector(selectUserLanguage);
    var locale$1 = (_a = CountriesLocale[language]) !== null && _a !== void 0 ? _a : locale.enGB;
    var handleFormatDate = useCallback(function (date, dateFormat) {
        if (!date) return null;
        var parsedDate = isDateAsString(date) ? parseStringToDate(date) : date;
        if (!parsedDate) return null;
        return dateFns.format(parsedDate, dateFormat !== null && dateFormat !== void 0 ? dateFormat : 'P pp', {
            locale: locale$1
        });
    }, [locale$1]);
    return {
        formatDate: handleFormatDate
    };
};

function useQuery() {
    var location = useLocation();
    var _a = useState(new URLSearchParams(location.search)),
        searchParams = _a[0],
        setSearchParams = _a[1];
    useEffect(function () {
        setSearchParams(new URLSearchParams(location.search));
    }, [location.search]);
    return searchParams;
}
var getQueryParamsByName = function (params) {
    var query = useQuery();
    var filter = useMemo(function () {
        return reduce(Object.values(params), function (acc, filter) {
            var _a;
            var value = query.get(filter);
            return typeof value === 'string' ? __assign(__assign({}, acc), (_a = {}, _a[filter] = value, _a)) : acc;
        }, {});
    }, [query]);
    return filter;
};

var useConfirm = function () {
    var _a = useState(null),
        promptProps = _a[0],
        setPromptProps = _a[1];
    var confirmAction = useCallback(function (promptProps) {
        return setPromptProps(promptProps);
    }, []);
    return {
        ConfirmBody: promptProps ? jsx(Prompt, __assign({}, promptProps, { onConfirm: (promptProps === null || promptProps === void 0 ? void 0 : promptProps.onConfirm) ? function () {
                promptProps.onConfirm();
                setPromptProps(null);
            } : undefined, onClose: function () {
                (promptProps === null || promptProps === void 0 ? void 0 : promptProps.onClose) && promptProps.onClose();
                setPromptProps(null);
            } })) : null,
        confirmAction: confirmAction
    };
};

var MAP_ID = 'App_map';
var INFO_WINDOW_CONTAINER = 'INFO_WINDOW_CONTAINER';
// helper functions
var createGoogleAdvancedMarkers = function (map, data, setTooltipData) {
    var _a, _b;
    var markersData = (_b = (_a = data === null || data === void 0 ? void 0 : data.filter(Boolean)) === null || _a === void 0 ? void 0 : _a.map(function (_a, index) {
        var id = _a.id,
            lat = _a.lat,
            lng = _a.lng,
            component = _a.component,
            onClick = _a.onClick,
            _b = _a.draggable,
            draggable = _b === void 0 ? null : _b,
            _c = _a.tooltip,
            tooltip = _c === void 0 ? null : _c,
            _d = _a.order,
            order = _d === void 0 ? GoogleMarkerOrder.site : _d;
        var container = document.createElement('div');
        container.innerHTML = renderToString(component());
        container.style.cursor = tooltip && !onClick ? 'default' : 'inherit';
        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: lat, lng: lng },
            content: container,
            zIndex: index,
            gmpDraggable: draggable === null || draggable === void 0 ? void 0 : draggable.enabled
        });
        if (onClick) {
            marker.addListener('click', function () {
                onClick();
            });
        }
        if (draggable === null || draggable === void 0 ? void 0 : draggable.enabled) {
            marker.addListener('dragend', function (e) {
                draggable.onDragEnd(e.latLng.lat(), e.latLng.lng());
            });
        }
        if (tooltip) {
            // tooltip display require `click` event to be present
            marker.addListener('click', function () {});
            marker.content.addEventListener('mouseover', function () {
                setTooltipData({
                    component: tooltip,
                    position: getTooltipPositionForAdvancedMarker(map, { lat: lat, lng: lng })
                });
            });
            marker.content.addEventListener('mouseleave', function () {
                setTooltipData(null);
            });
        }
        marker.id = id;
        marker.tooltip = tooltip;
        marker.order = order;
        return marker;
    })) !== null && _b !== void 0 ? _b : [];
    return markersData;
};
var getTooltipPositionForAdvancedMarker = function (map, position) {
    var projection = map.getProjection();
    var bounds = map.getBounds();
    var topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
    var bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = projection.fromLatLngToPoint(position);
    return {
        left: Math.floor((worldPoint.x - bottomLeft.x) * scale) + 12,
        top: Math.floor((worldPoint.y - topRight.y) * scale) - 24
    };
};
var getMapVisibleMarkers = function (_a) {
    var _b, _c, _d;
    var map = _a.map,
        data = _a.data,
        _e = _a.oldMarkers,
        oldMarkers = _e === void 0 ? [] : _e,
        _f = _a.setTooltipData,
        setTooltipData = _f === void 0 ? function () {} : _f;
    var prevMarkers = __spreadArray([], oldMarkers !== null && oldMarkers !== void 0 ? oldMarkers : [], true);
    var prevIds = prevMarkers.map(function (pm) {
        return pm.id;
    });
    var visibleIds = (_b = data === null || data === void 0 ? void 0 : data.map(function (el) {
        return el.id;
    })) !== null && _b !== void 0 ? _b : [];
    var prevIdsToPersist = prevIds.filter(function (prevId) {
        return visibleIds.includes(prevId);
    });
    var prevIdsToRemove = prevIds.filter(function (prevId) {
        return !visibleIds.includes(prevId);
    });
    var newIdsToDisplay = visibleIds.filter(function (vId) {
        return !prevIdsToPersist.includes(vId);
    });
    var newMarkersToDisplay = createGoogleAdvancedMarkers(map, data.filter(function (d) {
        return newIdsToDisplay.includes(d.id);
    }), setTooltipData);
    var prevMarkersToDisplay = (_c = prevMarkers === null || prevMarkers === void 0 ? void 0 : prevMarkers.filter(function (pm) {
        return prevIdsToPersist.includes(pm.id);
    })) !== null && _c !== void 0 ? _c : [];
    // clear old markers
    clearVisibleMarkers(oldMarkers === null || oldMarkers === void 0 ? void 0 : oldMarkers.filter(function (pm) {
        return prevIdsToRemove.includes(pm.id);
    }));
    var dataToDisplay = (_d = prevMarkersToDisplay === null || prevMarkersToDisplay === void 0 ? void 0 : prevMarkersToDisplay.concat(newMarkersToDisplay)) === null || _d === void 0 ? void 0 : _d.sort(function (a, b) {
        return a.order - b.order;
    });
    dataToDisplay === null || dataToDisplay === void 0 ? void 0 : dataToDisplay.forEach(function (m, i) {
        m.zIndex = i;
    });
    return dataToDisplay;
};
/**
 * `clearVisibleMarkers` - remove all markers from the map
 * @param markers - array of GoogleMarkerElementModel
 */
var clearVisibleMarkers = function (markers) {
    markers.forEach(function (marker) {
        marker.map = null;
        marker.tooltip = null;
        marker.removeEventListener('click', function () {});
        marker.removeEventListener('dragend', function () {});
        marker.content.removeEventListener('mouseover', function () {});
        marker.content.removeEventListener('mouseleave', function () {});
    });
};
var isPositionGoogleMapsLatLng = function (position) {
    return typeof position.lat !== 'number';
};
var isNumericGridRegExp = /^\d{6}(\.\d+)?$/;
var isCorrectLatRegExp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
var isCorrectLngRegExp = /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
var testIsCorrectLongitude = function (lng) {
    if (!lng) {
        return false;
    }
    var isGPS = isCorrectLngRegExp.test(lng);
    var isNumericGrid = isNumericGridRegExp.test(lng);
    return isGPS || isNumericGrid;
};
var testIsCorrectLatitude = function (lat) {
    if (!lat) {
        return false;
    }
    var isGPS = isCorrectLatRegExp.test(lat);
    var isNumericGrid = isNumericGridRegExp.test(lat);
    return isGPS || isNumericGrid;
};
var LIBRARIES = ['marker', 'geometry'];
var useGoogleMapInitialized = function (_a) {
    var apiKey = _a.apiKey,
        center = _a.center,
        zoom = _a.zoom,
        onLoad = _a.onLoad;
    var isLoaded = useJsApiLoader({
        id: MAP_ID,
        googleMapsApiKey: apiKey,
        libraries: LIBRARIES
    }).isLoaded;
    var _b = useState(null),
        map = _b[0],
        setMap = _b[1];
    var _c = useState([]),
        setVisibleMarkers = _c[1];
    var _d = useState(null),
        tooltipData = _d[0],
        setTooltipData = _d[1];
    // info window
    var infoWindow = useMemo(function () {
        if (!map) return null;
        return new google.maps.InfoWindow({
            maxWidth: 264,
            zIndex: 30,
            content: renderToString(jsx("div", { id: INFO_WINDOW_CONTAINER }))
        });
    }, [map]);
    useEffect(function () {
        if (!map) return;
        map.setOptions({ mapId: MAP_ID });
    }, [map]);
    var Wrapper = useCallback(function (_a) {
        var _b, _c;
        var children = _a.children,
            tooltip = _a.tooltip;
        var showTooltip = !isNil(tooltip);
        return jsx(Fragment, { children: jsxs(GoogleMap, { id: MAP_ID, mapContainerStyle: { position: 'relative', height: '100%', width: '100%' }, onLoad: function (map) {
                    setMap(map);
                    onLoad === null || onLoad === void 0 ? void 0 : onLoad();
                }, onUnmount: function () {
                    return setMap(null);
                }, center: center, zoom: zoom, children: [children, showTooltip && jsx("div", { style: __assign(__assign(__assign({ backgroundColor: 'white', borderRadius: '8px', padding: 4, border: '1px solid black' }, (_b = tooltip === null || tooltip === void 0 ? void 0 : tooltip.customStyles) !== null && _b !== void 0 ? _b : {}), { position: 'absolute', zIndex: 9999999 }), (_c = tooltip === null || tooltip === void 0 ? void 0 : tooltip.position) !== null && _c !== void 0 ? _c : { top: 0, left: 0 }), children: tooltip.component })] }) });
    }, [onLoad, center, zoom]);
    var WrapperToReturn = isLoaded ? Wrapper : function (_) {
        return jsx("div", { className: "w-full h-full", children: jsx(LoadingData, {}) });
    };
    //
    return {
        map: map,
        Wrapper: WrapperToReturn,
        infoWindow: infoWindow,
        /**
         * `setVisibleMarkers` - helper state that needs to be used with useEffect in order to update markers on the map
         *  @description can be used only once per `useMapInitialized` instance
         */
        setVisibleMarkers: setVisibleMarkers,
        /**
         * `tooltipData` - needs to be passed to <Wrapper /> component
         */
        tooltipData: tooltipData,
        /**
         *  `setTooltipData` - setter for `tooltipData` that needs to be passed onto `getMapVisibleMarkers` function
         */
        setTooltipData: setTooltipData
    };
};

var useResizeObserver = function () {
    var elementRef = useRef(null);
    var _a = useState({ width: 0, height: 0 }),
        size = _a[0],
        setSize = _a[1];
    useEffect(function () {
        if (!elementRef.current) {
            return function () {};
        }
        var resizeObserver = new ResizeObserver(function () {
            setSize(function (prev) {
                return {
                    width: elementRef.current.offsetWidth !== prev.width ? elementRef.current.offsetWidth : prev.width,
                    height: elementRef.current.offsetHeight !== prev.height ? elementRef.current.offsetHeight : prev.height
                };
            });
        });
        resizeObserver.observe(elementRef.current);
        return function () {
            resizeObserver.disconnect();
        };
    }, [elementRef.current]);
    return {
        /**
         * elementRef - reference for an element that should be measured
         */
        elementRef: elementRef,
        /**
         * size - width and height of an element
         */
        size: size
    };
};

var usePagination = function (pageSize) {
    var _a = useState(0),
        pageCount = _a[0],
        setPageCount = _a[1];
    var _b = useState(1),
        currentPage = _b[0],
        setCurrentPage = _b[1];
    var _c = useState(0),
        itemsTotal = _c[0],
        setItemsTotal = _c[1];
    var setPagination = useCallback(function (itemsTotal, currentPage) {
        var total = itemsTotal || 0;
        var page = currentPage || 1;
        var tempPageCount = Math.ceil(total / pageSize);
        var tempCurrentPage = total ? page : 1;
        setPageCount(tempPageCount !== null && tempPageCount !== void 0 ? tempPageCount : 0);
        setCurrentPage(tempCurrentPage);
        setItemsTotal(total);
    }, [pageSize]);
    var resetPagination = function () {
        setPageCount(0);
        setCurrentPage(1);
        setItemsTotal(0);
    };
    return {
        pageCount: pageCount,
        currentPage: currentPage,
        setPagination: setPagination,
        itemsTotal: itemsTotal,
        resetPagination: resetPagination
    };
};

export { CountriesLocale as C, INFO_WINDOW_CONTAINER as I, MAP_ID as M, useHandleError as a, useHandleSuccess as b, createMessage as c, CountriesDateFormats as d, formatDateForApi as e, formatDateWithCustomCountry as f, useFormatDate as g, useQuery as h, isDateAsString as i, getQueryParamsByName as j, useConfirm as k, getMapVisibleMarkers as l, clearVisibleMarkers as m, isPositionGoogleMapsLatLng as n, isNumericGridRegExp as o, parseStringToDate as p, isCorrectLatRegExp as q, isCorrectLngRegExp as r, testIsCorrectLatitude as s, testIsCorrectLongitude as t, useNotifications as u, useGoogleMapInitialized as v, useResizeObserver as w, usePagination as x };
